import { useCallback } from 'react';

import {
  UserConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

const useConnectionFailed = () => {
  const { handleUpdateUserConnectionModalScreen } = useSFConnectionState();

  const handleGoBack = useCallback(() => {
    handleUpdateUserConnectionModalScreen(
      UserConnectionModalScreens.CONNECTION_EDIT_SCREEN,
    );
  }, [handleUpdateUserConnectionModalScreen]);

  return {
    handleGoBack,
  };
};

export { useConnectionFailed };
